/*
 * Title:  Rewards/EarnTabContent.tsx
 * Author: Chris Rosa
 * Email: chris@encore.fans
 * Description: Earn Content page content listing, click on list to expand.
 * Date: 30 Jun 2022
 * Copyright (c) Encore, 2022
 * Version:0.1.0
 */

import { useState, useRef, Fragment, useEffect } from "react";
import Icon from "@components/Icon";
import { formatPhoneNumber, handleDescription, handleTitle, isMobileName, isOrlando, makeSecureUrl, routerLink } from "@helpers/common";
import { Dialog, Transition } from "@headlessui/react";
import { toast } from "react-toastify";
import copy_check from "@assets/copy_check.png";
import QrPopUp from "@components/QrPopUp";
import { useSelector } from "react-redux";
import FollowTimer from "@components/FollowTimer";
import { calculateRedumptionTiime } from "@helpers/common";
import service from "@services/callback-service";
import Loader from "@components/Loader";
import {
  handleFanSocialAuth,
  fanSocialTouchpoints,
} from "@helpers/socialAuth";
import BadgeCompleted from "./BadgeCompleted";
import TextCompleted from "./TextCompleted";
import store from "@store/configureStore";
import SubscriptionEmail from "@components/VerificationAction/SubscriptionEmail";
import SubscriptionSms from "@components/VerificationAction/SubscriptionSms";
import common from "@common/common";
import NotificationService from "@services/notification-service";
import Emitter from "@services/emitter-service";
import { SmsEarnItemCard } from "@components/SmsEarnItemCard";
import Mixpanel from "@services/mixpanel-events";
import { Dob } from "@components/FanInfo/Dob";
import { FanName } from "@components/FanInfo/FanName";
import Api from "@services/api";
import Management from "@services/management-service";

type Props = {
  item: {
    id: string;
    label: string;
    action: string;
    dynamic: boolean;
    points: number;
  }[];
  redeemed: Boolean;
  touchpoint: {
    id: string;
    label: string;
    touchpoint: string;
    description: string;
    image: string;
  };
};

const EarnContentItem: React.FC<Props | any> = (props) => {
  const [toggleHeight, setToggleHeight] = useState(false);
  const [touchpoint, setTouchpoint] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isShow, setIsShow] = useState(false);
  const [isAuthorize, setIsAuthorize] = useState(false);
  const [isAuthorizeLoader, setIsAuthorizeLoader] = useState(false);
  const  management = Management.get();
  const cname = management?.creator?.username;
  const fan = useSelector((state:any)=>state.score.data);
  const user = useSelector((state: any) => state.user);
  const typeformRef = useRef(null);
  const inputFileRef = useRef(null);
  const data = useSelector((state: any) =>
  Object.assign({}, state.user?.user?.user)
);
  const socialConnection = useSelector((state: any) => state?.score?.data?.socials || {});
  const creatorData = useSelector((state: any) => state?.creator);
  const programUrl =
    creatorData?.creator?.username + "/" + creatorData?.program?.name;

  const socialType = (props.item.type || "").slice(
      (props.item.type || "").indexOf(":") + 1
    );

  const toggleHandler = async () => {
    if(disabled){
      return;
    }
    if (!toggleHeight) {
      Mixpanel.send(`Action Tapped -- ${props?.item?.title}`, {action_name: props?.item?.title})
    }
    if(!props.item?.dynamic){
      if(props.item?.config?.redirectUrl){
        navigateToLink();
        return;
      } else if(isMobile() &&  props?.item?.touchpoint?.name == "qrcode") {
        props.openCamera();
        return;
      }
      
    }
    if(props?.item?.action =="typeform"){
      const data = {
        isOpen : true,
        data : `https://form.typeform.com/to/${props.item?.config?.typeformId}?typeform-source=${process.env.REACT_APP_BASE_URL}#fanid=${props.user?.user?.id}&programid=${creatorData?.program?.id}&actionid=${props.item?.id}`
      }
      Emitter.emit('typeFormPopup',data);
      return;
    }
    if(props?.item?.touchpoint?.name == "featured" && props.item?.action == "subscribe"){
      props.subscribe();
      return;
    }
    if(props?.item?.touchpoint?.name == "survey" ){
      props.startSurvey(props.item);
      return;
    }
    if(props.item?.config?.url &&
      props.item.action != "newFollow" &&
      props?.item?.touchpoint?.name != "typeform" &&
      props?.item?.touchpoint?.name != "qrcode" &&
      props?.item?.touchpoint?.name != "shopify" &&
      props.item?.action != "refer"){
        if(props.item?.type.includes("socialMedia") && props.item?.action!=="connect"){
          const socketData = {
            "score": {},
            "data": {...props.item, action:"processing"}
          }
          store.dispatch({type:"UPDATE_SOCIAL_ACTION_ITEM_IDS", data:props.item?.id})
          service.addToNotificationQueue(socketData);
        
          window.open(makeSecureUrl(props.item?.config?.url), "_blank");
         
        } else if (props.item?.type === "links") {
          window.open(makeSecureUrl(props.item?.config?.url), "_blank");
          const data = {
            query: "scanner-event",
            programId: user?.user?.user?.programId,
            creatorId: user?.user?.user?.creatorId,
            fanId: user?.user?.user?.id,
            actionId: props.item?.id,
            eventId: '',
						seed: ''
          };
          await Api.touchpointActionEgnage(data);
        } else {
          window.location.href = makeSecureUrl(props.item?.config?.url);
        }
        
        return;
      }

      if(props.item?.action == "connect"){

        if (isRedirect) {
          handleFanSocialAuth(
            socialType.toLowerCase(),
            props.item?.touchpoint?.id,
            props.item
          );
        } else {
          setIsAuthorize(true)
         
        }

        return;
      }
    setToggleHeight(!toggleHeight);
  };

  const viewQrcode = (actionItem) => {
    if (props.item?.touchpoint?.name == "qrCode") {
      setTouchpoint(actionItem);
    }
  };


  const isMobile = () => {
    var userAgent = navigator.userAgent;

    if (/windows phone/i.test(userAgent)) {
      return true;
    }
    if (/android/i.test(userAgent)) {
      return true;
    }
    if (/iPad|iPhone|iPod/.test(userAgent)) {
      return true;
    }

    return false;
  };

  const navigateToLink = () => {
    let link = props.item?.config?.eventUrl;
    if (props.item?.touchpoint?.name == "typeform") {
      window.open(props.item?.config?.url, "_blank");
    } else {
      if (props.item?.config?.redirectUrl) {
        window.open(link, "_blank");
        setTimeout(() => {
          //callbackService.fetchScoreTouchpoint()
        }, 3000);
      } else {
        if (isMobile()) {
          inputFileRef?.current?.click();
        }
      }
    }
  };

  const authorize = async () => {
    const data  = {
      id: socialConnection?.[socialType.toLowerCase()],
      programId: creatorData?.program?.id,
      fanId: props.user?.user?.id,
      actionId: props.item?.id,
      tpId: props.item?.touchpoint?.id,
      pointsEarned: props.item?.points,
      details: {}
    }
    setIsAuthorizeLoader(true)
    await props.authorize(data);
    setIsAuthorizeLoader(false)
    setIsAuthorize(false)
  }

  const handleSubscribe = async (field, value) => {
    const data  = {
      programId: creatorData?.program?.id,
      fanId: props.user?.user?.id,
      actionId: props.item?.id,
      tpId: props.item?.touchpoint?.id,
      pointsEarned: props.item?.points,
      details: {
        [field]: value
      }
    }
    setIsAuthorizeLoader(true)
    const json = await props.authorize(data);
    if(json?.status !== 201 && json?.status !== 200){
      Mixpanel.send("Error Recieved", {page_path : "/earn", error_message: json?.data?.message || "An error occurred"})
      NotificationService.error(json?.data?.message || "An error occurred")
    }
    setIsAuthorizeLoader(false)
  }


  const redemptionInfo = props.redemptionInfo || {};

  const config = calculateRedumptionTiime(
    props.item?.config,
    props.item?.shares?.lastEngagement,
    props.item?.shares?.fanEngagement,
    props.item?.totalEngagements,
    -1
  );
  // const redeemed = config?.isRedeemed;
  const redeemed = config?.isDisabled;
  const disabled = config?.isDisabled;

  
  let isRedirect = true;
  const connect =
    props.item?.config?.limit == props.item?.shares?.fanEngagement;

  const isCardDisabled = (props.item.isDisabled)?true:props.item?.socialAction?.id && props.item?.action!="connect";

  let description = props.item.description;
  let title = (props.item.title || "").replace("{hashtag}", (props.item?.config?.hashtag || ""));

  if(disabled && props.item.action=="email" || props.item.action=="sms"){
    if (props.item.action === "sms" && props.item.description.includes('You can opt-out at any time')) {
      description = props.item.description
    } else {
      description = "";
    }
  }

  if(disabled && props.item.action=="connect"){
    if(props.item.type.includes("tiktok")){
      if(!!socialConnection?.tiktokUsername){
        description = `Connected as <span class="font-semibold text-[15px]">${(socialConnection?.tiktokUsername || "")}</span>`;
      }
      
    }
    if(props.item.type.includes("youtube")){
      if(!!socialConnection?.youtubeUsername){
        description = `Connected as <span class="font-semibold text-[15px]">${(socialConnection?.youtubeUsername || "")}</span>`;
      }
      
    }
    if(props.item.type.includes("instagram")){
      if(!!socialConnection?.instagramUsername){
        description = `Connected as <span class="font-semibold text-[15px]">${(socialConnection?.instagramUsername || "")}</span>`;
      }
      
    }
    if(props.item.type.includes("facebook")){
      if(!!socialConnection?.facebookUsername){
        description = `Connected as <span class="font-semibold text-[15px]">${(socialConnection?.facebookUsername || "")}</span>`;
      }
      
    }
    if(props.item.type.includes("twitter")){
      if(!!socialConnection?.twitterUsername ){
        description = `Connected as <span class="font-semibold text-[15px]">${(socialConnection?.twitterUsername || "")}</span>`;
      }
      
    }
  } else if(!disabled && props.item.action=="connect"){
    description = "";
  }
  if(!disabled && props.item.action=="connect"){
    if(props.item.type.includes("tiktok") &&  socialConnection?.tiktok){
      title = `Authorize TikTok`;
      description = `Connected as <span class="font-semibold text-[15px]">${(socialConnection?.tiktokUsername || "")}</span>`;
      isRedirect = false;
    }
    if(props.item.type.includes("youtube") && socialConnection?.youtube){
      title = `Authorize Youtube`;
      description = `Connected as <span class="font-semibold text-[15px]">${(socialConnection?.youtubeUsername || "")}</span>`;
      isRedirect = false;
    }
    if(props.item.type.includes("instagram") && socialConnection?.instagram){
      title = `Authorize Instagram`;
      description = `Connected as <span class="font-semibold text-[15px]">${(socialConnection?.instagramUsername || "")}</span>`;
      isRedirect = false;
    }
    if(props.item.type.includes("facebook") && socialConnection?.facebook){
      title = `Authorize Facebook`;
      description = `Connected as <span class="font-semibold text-[15px]">${(socialConnection?.facebookUsername || "")}</span>`;
      isRedirect = false;
    }
    if(props.item.type.includes("twitter") && socialConnection?.twitter){
      title = `Authorize X`;
      description = `Connected as <span class="font-semibold text-[15px]">${(socialConnection?.twitterUsername || "")}</span>`;
      isRedirect = false;
    }
  }
  if(isCardDisabled && props.item.type.includes("socialMedia")){
    if(props.item.type.includes("tiktok")){
      if (socialConnection?.tiktok) {
        description = `Authorize TikTok to unlock`;
      } else {
        description = "Share your handle to unlock."
      }
    }
    if(props.item.type.includes("youtube")){
      if (socialConnection?.youtube) {
        description = `Authorize Youtube to unlock`;
      } else {
        description = "Share your handle to unlock."
      }
    }
    if(props.item.type.includes("instagram")){
      if (socialConnection?.instagram) {
        description = `Authorize Instagram to unlock`;
      } else {
        description = "Share your handle to unlock."
      }
    }
    if(props.item.type.includes("facebook")){
      if (socialConnection?.facebook) {
        description = `Authorize Facebook to unlock`;
      } else {
        description = "Share your handle to unlock."
      }
    } 
    if(props.item.type.includes("twitter")){
      if (socialConnection?.twitter) {
        description = `Authorize X to unlock`;
      } else {
        description = "Share your handle to unlock."
      }
    }
  }

  title = handleTitle(props?.item, title);
  description = handleDescription(props?.item, description);

  if(props.item.action=="email"){
    description = disabled && (fan?.email || fan?.extraInfo?.email);
  };

  if(props.item.action=="sms"){
    description = disabled && formatPhoneNumber((fan?.phoneNumber || fan?.extraInfo?.phoneNumber));
  };

  const isToggle = ['refer', 'email', 'sms', 'shareDob', 'collectName']?.includes(props.item?.action);

  return (
    <div 
    data-testid={`card-${props.item?.action}`} 
    className={`relative bg-tile p-[10px_10px] transition-all duration-700 ease-in-out rounded-[10px] cursor-pointer`}>
      <div
        onClick={(e) => {
          if (e.defaultPrevented) return;
          if(isCardDisabled) return;
          toggleHandler();
        }}
        className={`${
          toggleHeight ? "max-h-[100vh] transition-[max-height] ease-in-out duration-1000 " : (props.item?.action == "email" && disabled && description) ? "lg:max-h-[85px] max-h-[85px]" : ["email", "sms", "collectName", "shareDob"]?.includes(props.item?.action) ? "lg:max-h-[40px] max-h-[40px]" : props.item?.action == "refer" ? 'sm:max-h-[77px] max-h-[79px]' : ''
        } ${isToggle ? 'p-[4px_10px]' : description ? 'p-[15px_10px]' : 'p-[4px_10px]'} transition-all duration-700 ease-in-out rounded-[10px] relative cursor-pointer overflow-hidden`}
        key={props.item?.id}
      >
        <div className="flex justify-between items-center">
            <div className="flex items-center gap-2">
              {props.item?.type.includes("socialMedia") &&
                <Icon icon={socialType} item={props.item} className="w-[30px] h-[30px]" />
                }
                <h4 data-testid={`title-${props.item?.action}`} className={`${isToggle ? (disabled ? 'my-[8px]': "mt-[8px]"): ''} font-[550] leading-5 tile-inlay-primary text-[16px]`}>
                {title}
                </h4>
                {
                  isCardDisabled && 
                  <svg width="10" height="13" className="opacity-50" viewBox="0 0 10 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8 6.5H9.05C9.29855 6.5 9.5 6.70145 9.5 6.95V12.05C9.5 12.2986 9.29855 12.5 9.05 12.5H0.95C0.701472 12.5 0.5 12.2986 0.5 12.05V6.95C0.5 6.70145 0.701472 6.5 0.95 6.5H2M8 6.5V3.5C8 2.5 7.4 0.5 5 0.5C2.6 0.5 2 2.5 2 3.5V6.5M8 6.5H2" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                }
            </div><BadgeCompleted item={props.item} />
        </div>
        {/* expanded  */}
        {!!description &&
        <p data-testid={`desc-${props.item?.action}`}
          className={`${
            toggleHeight ? null : ""
          } text-[15px] font-normal leading-[18px] opacity-80 mt-3 tile-inlay-primary tracking-wider description_link`}
          dangerouslySetInnerHTML={{
            __html: description || "<br/>",
          }}
        ></p>}
        {props.item?.action == "refer" && !disabled && (
          <>
            <div data-testid={`field-${props.item?.action}`} className="mt-5">
              <div className="flex items-center gap-x-3 rounded-xl bg-tile-form">
                <>
                  <div data-testid="copybtn" className="h-[35px] px-3 min-w-[215px] grow flex items-center justify-center cursor-text rounded-full opacity-80">
                    <p className="tile-inlay-primary text-[15px] font-normal truncate">
                      {`${routerLink(programUrl)}/?invite=${
                        props.user?.user?.id
                      }&a=${props.item.id}`}
                    </p>
                  </div>
                  <div
                    onClick={() => {
                      navigator.clipboard.writeText(
                        `${routerLink(programUrl)}/?invite=${
                          props.user?.user?.id
                        }&a=${props.item?.id}`
                      );
                      toast.success(
                        <div className="flex items-center gap-x-3 tile-inlay-primary text-[14px]">
                          <img
                            alt="logo"
                            src={copy_check}
                            className="h-[20px] w-[20px] object-contain"
                          />
                          Link copied!
                        </div>,
                        {
                          icon: false,
                          position: "bottom-center",
                          autoClose: 5000,
                          hideProgressBar: false,
                          closeOnClick: true,
                          pauseOnHover: true,
                          draggable: true,
                          // progress: undefined,
                          theme: "light",
                        }
                      );
                    }}
                    className="h-[35px] w-[35px] flex-shrink-0 rounded-full flex items-center justify-center"
                  >
                    <svg
                      className="h-5 w-5 copy-icon-color"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      {" "}
                      <rect
                        x="9"
                        y="9"
                        width="13"
                        height="13"
                        rx="2"
                        ry="2"
                      />{" "}
                      <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
                    </svg>
                  </div>
                </>
              </div>
              
            </div>
          </>
        )}
        {!props.item?.dynamic && (
          <>
            {props.item?.config?.redirectUrl ? (
              <>
                {/* <div className="divide-y h-[1px] w-full bg-gray-600 my-[20px] bg-opacity-40" /> */}
                <div className="mt-5 hidden">
                  <div className="flex items-center gap-x-3">
                    <div className="justify-center flex w-full">
                      <button
                      data-testid={`btnqr-${props.item?.action}`}
                        disabled={disabled}
                        onClick={navigateToLink}
                        className={`w-full h-[42px] max-w-[300px] ${
                          !disabled
                            ? "bg-btn border-primary btn-inlay-primary "
                            : "bg-[#616161] text-white"
                        } border-black text-gray  rounded-[50px]`}
                      >
                        <span className="text-inherit">
                          {disabled ? "complete" : "go"}
                        </span>
                      </button>
                    </div>
                  </div>
                  <>
                    {/* {!!config?.humanize &&
              
                <p className="text-[14px] leading-[14px] font-normal text-[#44CD51] text-center mt-[10px]">{`available again in ${config?.humanize}`} </p>
              } */}
                  </>
                </div>
              </>
            ) : (
              <>
                {isMobile() ||
                  ("lastRedemption" in redemptionInfo && (
                    {/* <div className="divide-y h-[1px] w-full bg-gray-600 my-[20px] bg-opacity-40" /> */}
                  ))}
                <div className={`mt-6 hidden`}>
                  <div className="flex items-center gap-x-3">
                    <div className="justify-center flex w-full">
                      {isMobile() &&
                        props?.item?.touchpoint?.name == "qrcode" && (
                          <button
                            disabled={disabled}
                            onClick={props.openCamera}
                            className={`w-full h-[42px] max-w-[300px] ${
                              !disabled
                                ? "bg-btn border-primary  btn-inlay-primary"
                                : "bg-[#616161] text-white"
                            } border-black text-gray  rounded-[50px]`}
                          >
                            <span className="text-inherit">
                              {disabled ? "complete" : "scan QR code"}
                            </span>
                          </button>
                        )}
                    </div>
                  </div>

                  <>
                    {/* {!!config?.humanize &&
            
              <p className="text-[14px] leading-[14px] font-normal text-[#44CD51] text-center mt-[10px]">{`available again in ${config?.humanize}`} </p>
            } */}
                  </>
                </div>
              </>
            )}
            <input
              ref={inputFileRef}
              accept="image/*"
              id="scan-qr-code"
              className="invisible absolute"
              type="file"
              capture="environment"
            />
          </>
        )}
        {props?.item?.action == "typeform" && (
          <>
            {/* <div className="divide-y h-[1px] w-full bg-gray-600 my-[20px] bg-opacity-40" /> */}
            <div className="mt-5 hidden">
              <div className="flex items-center gap-x-3">
                <div className="justify-center flex w-full">
                  {props.item?.id && (
                    <div data-testid={`tform-${props.item?.action}`}
                      className="w-full flex justify-center items-center max-w-[300px] h-[42px] bg-[#616161] rounded-[50px] z-10 text-gray"
                      onClick={(e) => {
                        e.preventDefault();
                      }}
                    >
                    </div>
                  )}
                </div>
              </div>
            </div>
          </>
        )}
        {props.item?.action == "email" && (
           <>
           {!disabled &&
            <SubscriptionEmail handleSubscribe={handleSubscribe} isAuthorizeLoader={isAuthorizeLoader} data={data}/>
           }
         </>
          )}

          {props.item?.action == "shareDob" && (
            <>
                {!disabled &&
                  <Dob user={props?.user} item={props?.item} />
                }
            </>
          )}

          {props.item?.action == "collectName" && (
            <>
                {!disabled &&
                  <FanName user={props?.user} item={props?.item} />
                }
            </>
          )}

          
        {props?.item?.touchpoint?.name == "survey" && (
          <>
            {/* <div className="divide-y h-[1px] w-full bg-gray-600 my-[20px] bg-opacity-40" /> */}
            <div className="mt-5 hidden">
              <div className="flex items-center gap-x-3">
                <div className="justify-center flex w-full">
                  {props.item?.id && (
                    <button
                      disabled={redeemed}
                      className={`w-full max-w-[300px] h-[42px] ${
                        redeemed ? "bg-[#616161]" : "bg-btn"
                      }  rounded-[50px] text-gray`}
                      onClick={(e) => {
                        e.preventDefault();
                        props.startSurvey(props.item);
                      }}
                    >
                      <span
                        className={`${
                          disabled ? "text-white" : "btn-inlay-primary"
                        } `}
                      >
                        complete survey
                      </span>
                    </button>
                  )}
                </div>
              </div>
            </div>
          </>
        )}
        {props.item?.config?.url &&
          props.item.action != "newFollow" &&
          props?.item?.touchpoint?.name != "typeform" &&
          props?.item?.touchpoint?.name != "qrcode" &&
          props?.item?.touchpoint?.name != "shopify" &&
          props.item?.action != "refer" && (
            <>
              {/* <div className="divide-y h-[1px] w-full bg-gray-600 my-[20px] bg-opacity-40" /> */}
              <div className="mt-5 hidden">
                <div className="flex items-center gap-x-3">
                  <div className="justify-center flex w-full">
                    {props.item?.id && (
                      <a data-testid={`followbtn-${props.item?.action}`}
                        rel="noreferrer"
                        href={makeSecureUrl(props.item?.config?.url)}
                        target={"_blank"}
                        className="w-full lowercase max-w-[300px] h-[42px] bg-btn border border-primary rounded-[50px] flex items-center justify-center"
                      >
                        <span
                          className={`${
                            disabled ? "text-white" : "btn-inlay-primary"
                          } `}
                        >
                          {props.item.title}
                        </span>
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </>
          )}
        {props.item.action == "newFollow" && (
          <>
            {/* <div className="divide-y h-[1px] w-full bg-gray-600 my-[20px] bg-opacity-40" /> */}
            <div className="mt-5 hidden">
              <div className="flex items-center gap-x-3">
                <div className="justify-center flex w-full gap-2">
                  {redeemed ? (
                    <a
                      rel="noreferrer"
                      className="w-full max-w-[300px] h-[42px] bg-[#616161] rounded-[50px] flex items-center justify-center"
                    >
                      <span className="text-white">{props.item.title}</span>
                    </a>
                  ) : (
                    <>
                      {props.item?.pending ? (
                        <button
                          disabled
                          className="w-full max-w-[300px] h-[42px] bg-[#616161] rounded-[50px] zIndex-9 flex items-center justify-center"
                        >
                          <span className="text-white">
                            Pending <FollowTimer />
                          </span>
                        </button>
                      ) : (
                        <>
                          {props.connect && (
                            <button
                              onClick={() => setIsDrawerOpen(true)}
                              className="w-full max-w-[300px] h-[42px] bg-transperant border border-primary rounded-[50px] flex items-center justify-center tile-inlay-primary"
                            >
                              Confirm
                            </button>
                          )}
                          {props.item?.id && (
                            <a
                              href={makeSecureUrl(
                                props.item?.touchpoint?.url ?? props.item.url
                              )}
                              rel="noreferrer"
                              target={"_blank"}
                              className="w-full lowercase max-w-[300px] h-[42px] bg-btn border border-primary rounded-[50px] flex items-center justify-center"
                            >
                              <span
                                className={`${
                                  disabled ? "text-white" : "btn-inlay-primary"
                                } `}
                              >
                                {props.item.title}
                              </span>
                            </a>
                          )}
                        </>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </>
        )}
        {props.item?.action == "connect" &&
          fanSocialTouchpoints().includes(socialType.toLowerCase()) && (
            <div className="justify-center w-full gap-2 hidden">
              <button
              data-testid={`connectbtn-${props.item?.action}`}
                disabled={connect}
                onClick={() => {
                  if (isRedirect) {
                    handleFanSocialAuth(
                      socialType.toLowerCase(),
                      props.item?.touchpoint?.id,
                      props.item
                    );
                  } else {
                    const data  = {
                      id: socialConnection?.[socialType.toLowerCase()],
                      programId: creatorData?.program?.id,
                      fanId: props.user?.user?.id,
                      actionId: props.item?.id,
                      tpId: props.item?.touchpoint?.id,
                      pointsEarned: props.item?.point,
                      details: {}
                    }
                    props.authorize(data);
                  }
                }}
                className={`w-full max-w-[300px] h-[42px] ${
                  connect ? "bg-[#616161]" : "bg-btn"
                }  rounded-[50px] text-gray`}
              >
                <div
                  className={`${
                    disabled ? "text-white" : "btn-inlay-primary"
                  } `}
                >
                  {props.loader?.[props.item.id] ? (
                    <Loader height={30} width={30} white={true} />
                  ) : connect ? (
                    "connected"
                  ) : (
                    "connect"
                  )}
                </div>
              </button>
            </div>
          )}
        {props.item.action == "email" && isOrlando() && toggleHeight && 
          <div className="font-[400] text-[12px] leading-[14px] tracking-[0.02em] text-[black] opacity-50 mt-[10px]">
            By submitting this form, I consent to receive emails and/or messages from the Orlando Magic, Ltd. and/or its sponsors regarding their products and services, at the contact information that I have submitted, including my wireless number if provided. I understand these communications may be generated using an automated technology, that my consent is not required to participate in this sweepstakes, and that my consent will not increase my chance of winning.
          </div>
        }

      </div>
      {props.item?.action !== "sms" && (
      <TextCompleted item={props.item} />)
      }
      <QrPopUp data={touchpoint} click={viewQrcode} isFan={true} />

      <Transition appear show={isShow} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-50"
          onClose={() => {
            setIsShow(false);
          }}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-[0.85]" />
          </Transition.Child>

          <div className={`fixed inset-0`}>
            <div className="flex items-end justify-center min-h-full text-center">
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-700"
                enterFrom="translate-y-full"
                enterTo="translate-y-0"
                leave="transform transition ease-in-out duration-700"
                leaveFrom="translate-y-0"
                leaveTo="translate-y-full"
              >
                <Dialog.Panel className="w-screen max-w-[685px] transform overflow-hidden rounded-b-none rounded-t-[40px] text-left align-middle shadow-xl transition-all bg-[#1D1D1D]">
                  <div className="relative">
                    <button
                      type="button"
                      className="text-white rounded-md outline-none hover:text-white hover:opacity-70"
                      onClick={() => setIsShow(false)}
                    >
                      <span className="sr-only">Close panel</span>
                      <div className="w-[25px] h-1 absolute mx-auto top-[10px] left-0 right-0 bottom-0 rounded-full bg-lightBlack"></div>
                      {/* <svg className="w-8 h-8 text-red-500 absolute mx-auto top-[10px] left-0 right-0 bottom-0"  width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">  <path stroke="none" d="M0 0h24v24H0z"/>  <line x1="18" y1="6" x2="6" y2="18" />  <line x1="6" y1="6" x2="18" y2="18" /></svg> */}
                    </button>
                  </div>
                  <div className="px-[30px] text-center">
                    <h3 className="tile-inlay-primary font-[550] text-[24px] leading-[31px] mt-[41px]">
                      Connect {props?.item?.touchpoint?.name}
                    </h3>
                    <p className="mt-[15px] text-[18px] font-normal leading-[22px] tile-inlay-primary">
                      Please connect your {props?.item?.touchpoint?.name} to{" "}
                      {props.item?.title}
                    </p>
                    <div className="relative">
                      <button
                        onClick={() =>
                          handleFanSocialAuth(
                            socialType.toLowerCase(),
                            props.item?.touchpoint?.id,
                            props.item?.socialAction
                          )
                        }
                        className="font-medium bg-btn rounded-full lowercase btn-inlay-primary w-full max-w-[300px] mx-auto h-[41px] flex items-center justify-center my-[50px]"
                      >
                        connect
                      </button>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>

      <Transition appear show={isDrawerOpen} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-50"
          onClose={() => setIsDrawerOpen(false)}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-[0.85]" />
          </Transition.Child>

          <div className={`fixed inset-0`}>
            <div className="flex items-end justify-center min-h-full text-center">
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-700"
                enterFrom="translate-y-full"
                enterTo="translate-y-0"
                leave="transform transition ease-in-out duration-700"
                leaveFrom="translate-y-0"
                leaveTo="translate-y-full"
              >
                <Dialog.Panel className="w-screen max-w-[685px] transform overflow-hidden rounded-b-none rounded-t-[40px] text-left align-middle shadow-xl transition-all bg-body">
                  <div className="relative">
                    <button
                      type="button"
                      className="text-white rounded-md outline-none hover:text-white hover:opacity-70"
                      onClick={() => setIsDrawerOpen(false)}
                    >
                      <span className="sr-only">Close panel</span>
                      <div className="w-[25px] h-1 absolute mx-auto top-[10px] left-0 right-0 bottom-0 rounded-full bg-black"></div>
                      {/* <svg className="w-8 h-8 text-red-500 absolute mx-auto top-[10px] left-0 right-0 bottom-0"  width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">  <path stroke="none" d="M0 0h24v24H0z"/>  <line x1="18" y1="6" x2="6" y2="18" />  <line x1="6" y1="6" x2="18" y2="18" /></svg> */}
                    </button>
                  </div>
                  <div className="px-[30px] text-center">
                    <h3 className="black font-[550] text-[24px] leading-[31px] mt-[41px]">
                      We're on it!
                    </h3>
                    <p className="mt-[15px] text-[18px] font-normal leading-[22px] black">
                      You can close this window and we will keep working in the
                      background. It may take a few minutes to be rewarded.
                    </p>
                    <div className="relative">
                      <button
                        onClick={() => setIsDrawerOpen(false)}
                        className="font-medium bg-tile rounded-full black w-full max-w-[300px] mx-auto h-[41px] flex items-center justify-center my-[50px]"
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>

      {/* authorize drawer  */}
      <Transition appear show={isAuthorize} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-50"
          onClose={() => {}}
        >
          <div className={`fixed inset-0`}>
            <div className="flex items-end justify-center min-h-full text-center">
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-700"
                enterFrom="translate-y-full"
                enterTo="translate-y-0"
                leave="transform transition ease-in-out duration-700"
                leaveFrom="translate-y-0"
                leaveTo="translate-y-full"
              >


                <Dialog.Panel className="w-screen max-w-[685px] transform overflow-hidden rounded-b-none rounded-t-[40px] text-left align-middle transition-all bg-body" style={{boxShadow: '0px 0px 34px 0px rgba(0, 0, 0, 0.15)'}}>
                  <div className="relative">
                    <button
                      type="button"
                      onClick={() => {}}
                    >
                      <span className="sr-only">Close panel</span>
                      <div className="w-[25px] h-1 absolute mx-auto top-[10px] left-0 right-0 bottom-0 rounded-full opacity-20 bg-black"></div>
                      {/* <svg className="w-8 h-8 text-red-500 absolute mx-auto top-[10px] left-0 right-0 bottom-0"  width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">  <path stroke="none" d="M0 0h24v24H0z"/>  <line x1="18" y1="6" x2="6" y2="18" />  <line x1="6" y1="6" x2="18" y2="18" /></svg> */}
                    </button>
                  </div>
                  <div className="px-[30px] text-center">
                    <h3 className="body-inlay-primary font-[550] text-[24px] leading-[31px] mt-[41px]">
                      Do you want to share your {socialType} data with Encore?
                    </h3>
                    <p className="mt-[15px] text-[18px] font-normal leading-[22px] body-inlay-primary">
                      By authorizing below, you agree to share information about your account and history.
                    </p>
                    <div className="relative">
                      <button
                        onClick={authorize}
                        className="font-semibold bg-btn mt-[50px] rounded-full btn-inlay-primary w-32 mx-auto h-[41px] flex items-center justify-center"
                      >
                        {isAuthorizeLoader? <Loader height={30} width={30} white={true}  />:"authorize" }
                        
                       
                      </button>
                    </div>
                    <div className="relative">
                      <button
                        onClick={() => setIsAuthorize(false)}
                        className="font-semibold bg-black rounded-full text-white w-28 mx-auto h-[41px] flex items-center justify-center mt-[15px] mb-[50px]"
                      >
                        cancel
                      </button>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
      {props.item?.action == "sms" && (
        <>
        <div className={`${toggleHeight ? "max-h-[100vh] transition-[max-height] ease-in-out duration-1000 " : "lg:max-h-[0px] max-h-[0px] overflow-hidden"} ${isCardDisabled && "opacity-40"} pb-[5px] transition-all duration-700 ease-in-out rounded-[10px] relative cursor-pointer`}>
          {!disabled &&
          <SmsEarnItemCard item={props.item} disabledCard={true} 
          value={fan.phoneNumber || fan.extraInfo?.phoneNumber} disabledInput={(fan?.phoneNumber || fan?.extraInfo?.phoneNumber || "").length>9}
          />
            // <SubscriptionSms handleSubscribe={handleSubscribe} isAuthorizeLoader={isAuthorizeLoader} data={data}/>
          }
       </div>
       <TextCompleted item={props.item} />
       </>
      )}
    </div>
  );
};

export default EarnContentItem;